var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"Tab"},[_c('span',{staticClass:"u-hide"},[_vm._t("header")],2),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }